
























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AgroTimeLine from "@/components/agroTimeLine/AgroTimeLine.vue";
import * as analysesService from "@/services/analyses/index";
import { SummaryCropStagesDTO } from "@/api/analyses/types";
import { formattedDate } from "@/filters/date/index";
import { formattedAreaInHa } from "@/filters/area";
import { addDays } from "date-fns";

@Component({
  name: "TimeLineController",
  components: {
    AgroTimeLine,
  },
  filters: {
    formattedDate,
    formattedAreaInHa
  },
})
export default class TimeLineController extends Vue {
  @Prop({ type: String, required: true })
  private uuid!: string;

  @Prop({ type: String, required: false, default:'SOY' })
  private cropType!: string;

  @Prop({ type: String, required: false, default: 'SUMMER' })
  private harvestSeason!: string;

  private cropStepsList: SummaryCropStagesDTO[] = [];  

  private estimatedHarvestDays: number = 120;

  private async created() {
    await this.loadCropsSteps();
  }

  private async loadCropsSteps() {
    await analysesService.getAnalysisCropsStages(this.uuid, this.harvestSeason, this.cropType);
  }

  get cropsStageList() {
    return this.$store.state.analyses.analysisCropsStagesContext;
  }

  get analysisSummary() {
    return this.$store.state.analyses.analysisSummaryContext;
  }

  private getEstimatedHarvestDate(cropsStageList: SummaryCropStagesDTO[]) {
    if (
      !cropsStageList[0].averageDate &&
      cropsStageList[0].averageDate === null
    ) {
      return "";
    } else {
      const estimatedHarvestDate = cropsStageList[0].averageDate;
      return addDays(estimatedHarvestDate, this.estimatedHarvestDays);
    }
  }
}
